import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { Bar, BarChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import NoShipmentsYet from '../NoShipmentsYet/NoShipmentsYet';
import useUnsuccessfulPickups from './useUnsuccessfulPickups';

const UnsuccessfulPickups = () => {
  const hook = useUnsuccessfulPickups();
  return (
    <Card sx={{ p: 3, borderRadius: 3, boxShadow: 2, height: '100%' }}>
      <Typography variant="body1" sx={{ fontWeight: 600, mb: '1rem' }}>
        Desglose de recolecciones no exitosas
      </Typography>
      {hook.data.data?.length === 0 ? (
        <NoShipmentsYet />
      ) : (
        <ResponsiveContainer width="100%" height={400}>
          <BarChart
            layout="vertical"
            data={hook.data.data || []}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <XAxis type="number" />
            <YAxis dataKey="reason" type="category" label="Razón" width={100} />
            <Tooltip />
            <Legend
              formatter={(value) => (
                <span style={{ color: '#85c440' }}>{value === 'count' ? 'Cantidad' : 'Razón'}</span>
              )}
            />
            <Bar dataKey="count" name="Cantidad" fill="#85c440" barSize={30} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
};

export default UnsuccessfulPickups;
